<template>
  <div>
    <div class="grid">
      <div class="grid__cell col8-of-12--medium-up">
        <DashboardHeader
          heading="Matchmaking requests"
          paragraph="View all of the businesses that have submitted an agency matchmaking request"
        />
      </div>
      <div
        class="grid__cell col4-of-12--medium-up"
        style="text-align:right;"
        v-if="
          $store.state.vendorDashboard.details.vendorData.id ===
            '72887176-abc4-48d7-bdd6-35cf31aafb7e'
        "
      >
        <Toggle
          v-on:switchToggle="switchToggle($event)"
          left="External"
          right="Internal"
          :selected.sync="selectedToggle"
        ></Toggle>
      </div>
    </div>
    <template v-if="loading">
      <Logo />
    </template>
    <template v-else>
      <TableToolbar :query="filters.name.value" @update-query="filterRows">
        <div>
          <label style="margin-bottom: 0">
            <div class="select select-mb-0">
              <select
                @change="filterRows(['status'], $event.target.value, 'status')"
              >
                <option selected="selected" value>Status</option>
                <option :selected="filters.status.value == 'N'" value="N"
                  >New</option
                >
                <option :selected="filters.status.value == 'D'" value="D"
                  >Done</option
                >
                <option :selected="filters.status.value == 'P'" value="P"
                  >Pending</option
                >
              </select>
            </div>
          </label>
        </div>
      </TableToolbar>
      <div class="mb-lg">
        <v-table
          :data="rows"
          :filters="filters"
          :currentPage.sync="currentPage"
          :pageSize="pageSize"
          class="table table-bordered"
          @totalPagesChanged="totalPages = $event"
          :totalItemsInput="count"
        >
          <thead slot="head">
            <v-th
              v-on:sortChange="sortChange"
              v-for="(column, i) in columns"
              :key="i"
              :sortKey="column.name"
              class="mb-xxs grey-background fs-sm"
              >{{ column.displayName }}</v-th
            >
          </thead>
          <tbody
            slot="body"
            v-if="displayData.length"
            slot-scope="{ displayData }"
          >
            <tr
              v-for="(row, i) in displayData"
              :key="i"
              @click="
                $helpers.navigateOrNewTab(
                  `/matchmaking-requests/${isInternal}${row.id}`,
                  $router,
                  $event
                )
              "
            >
              <td class="fs-sm f-capitalize fw-semibold">
                {{ row.companyName }}
              </td>
              <td class="fs-sm f-capitalize">{{ showDate(row.created) }}</td>
              <td class="fs-sm f-capitalize">{{ row.assignedTo || '-' }}</td>
              <td class="fs-sm f-capitalize">
                {{ showDate(row.dateAssigned) || '-' }}
              </td>
              <td class="fs-sm f-capitalize">
                {{ getStatusText(row.status) }}
              </td>
            </tr>
          </tbody>
          <tbody
            style="padding: 1em; display: block;"
            class="fs-sm fw-semibold fc-medium"
            v-else
          >
            No matchmaking requests!
          </tbody>
        </v-table>
        <smart-pagination
          :currentPage.sync="currentPage"
          :count="count"
          :pageSize="pageSize"
          v-on:update:currentPage="pageChanged($event)"
        />
      </div>
    </template>
  </div>
</template>

<script>
import { formatDate } from '@/utils/date';
import TableToolbar from '@/components/Dashboard/TableToolbar';
import Toggle from '@/components/DesignSystem/Toggle';
import DashboardHeader from '@/components/Dashboard/DashboardHeader';
import Logo from '@/components/SpinningLogo';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters, mapActions, mapState } = createNamespacedHelpers(
  'matchmakingRequests/table'
);

export default {
  name: 'MatchmakingRequests',
  components: {
    TableToolbar,
    DashboardHeader,
    Logo,
    Toggle,
  },
  data() {
    return {
      currentPage: 1,
      totalPages: 3,
    };
  },
  computed: {
    ...mapGetters({
      columns: 'getColumns',
      rows: 'getRows',
      filters: 'getFilters',
    }),
    ...mapState(['count', 'pageSize', 'loading', 'selectedToggle', 'internal']),
    isInternal() {
      if (this.internal) {
        return 'internal/';
      } else {
        return '';
      }
    },
  },
  created() {
    this.fetchMatchmakingData(1);
  },
  methods: {
    ...mapActions([
      'updateQueryAndFilter',
      'fetchMatchmakingData',
      'sortResults',
      'switchToggle',
    ]),
    sortChange(key) {
      this.sortResults(key);
      this.currentPage = 1;
    },
    pageChanged(page) {
      this.fetchMatchmakingData(page);
    },
    filterRows(fields, value, type) {
      if (!fields) {
        fields = ['companyName'];
      }
      value = value.trimStart();
      this.currentPage = 1;
      this.updateQueryAndFilter({ fields, value, type });
    },
    showDate(date) {
      if (date) {
        return formatDate(new Date(String(date)));
      }
      return '-';
    },
    getStatusText(status) {
      switch (status) {
        case 'N':
          return 'New';
        case 'D':
          return 'Done';
        case 'P':
          return 'Pending';
        default:
          return status;
      }
    },
  },
};
</script>
